import Stats from "three/addons/libs/stats.module.js";

let statsPanels;

let myMap;

export const blankLayer = {
  id: 'blank-layer',
  type: 'custom',
  onAdd: (map, gl) => {
    myMap = map;
    const stats1 = new Stats();
    stats1.showPanel(0);
    document.body.appendChild(stats1.dom);

    const stats2 = new Stats();
    stats2.showPanel(1);
    stats2.dom.style.left = '80px';
    document.body.appendChild(stats2.dom);

    const stats3 = new Stats();
    stats3.showPanel(2);
    stats3.dom.style.left = '160px';
    document.body.appendChild(stats3.dom);
    statsPanels = [stats1, stats2, stats3];
  },
  render: () => {
    statsPanels.forEach(stats => stats.begin());
    myMap.triggerRepaint();
    statsPanels.forEach(stats => stats.end());
  }
}


export default blankLayer